import { MFA_LOGIN_CODES, MFA_SAVE_STATE_CODES, SETUP_2FA_CODE, EMAIL_CODE, CAPTCHA_CODE } from '@/utils/cons';

export function checkGlobalError({ status, resp, options = {} }) {
  if (status === 401) {
    if (resp.code === EMAIL_CODE) {
      this.$store.commit('auth/setMfaCode', resp.code);
      if (this.$store.state.auth.isLoggedIn) {
        this.$store.dispatch('logout');
      }
      return true;
    }
    if (resp.code === SETUP_2FA_CODE) {
      this.$store.commit('auth/setMfaCode', resp.code);
      return true;
    }
    if (MFA_LOGIN_CODES.includes(resp.code)) {
      this.$store.commit('auth/setMfaCode', resp.code);
      if (MFA_SAVE_STATE_CODES.includes(resp.code) && options.args) {
        this.$store.commit('setDelayedCall', options.args);
        this.$store.commit('auth/setIsForcedLogin', typeof options.force === 'undefined' ? true : options.force);
      }
      return true;
    }
    if (resp.code === CAPTCHA_CODE) {
      this.$store.commit('auth/setCaptchaIP', resp.details.ip);
      this.$store.commit('auth/setMfaCode', CAPTCHA_CODE);
      return true;
    }
    return false;
  }
  if (status === 413) {
    this.$notify({
      text: this.$gettext('Request entity too large'),
      type: 'error',
    });
    return true;
  }
  if (status === 500) {
    this.$notify({
      text: this.$gettext('Something went wrong'),
      type: 'error',
    });
    return true;
  }
  if (status === 502) {
    this.$store.commit('setErrorPageKey', 'errorBadGateway');
    return true;
  }
  return false;
}
